import { TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Inject, OnInit, ViewChild,} from '@angular/core';
import { FormBuilder, Validators, AbstractControl } from '@angular/forms';

// Material
import {  DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE,} from '@angular/material/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDatepicker } from '@angular/material/datepicker';



//rxjs
import { forkJoin, Observable, tap, of, throwError } from 'rxjs';
import { switchMap, map, catchError, filter  } from 'rxjs/operators';


import { CustomDateAdapter } from 'src/app/administration/workshops/dialogs/lock-settings/custom-date-picker-header/custom-date-adapter';
import { CUSTOM_DATE_FORMATS } from 'src/app/administration/workshops/dialogs/lock-settings/custom-date-picker-header/custom-date-formats';
import { SchedulingComponent } from '../../scheduling.component';

import { APICustomerBasicDataService } from 'src/services/api-services/api-customer-basic-data-service';

import { APISchedulerService } from 'src/services/api-services/api-scheduler-service';
import { APIServiceAdvisorService } from 'src/services/api-services/api-serviceadvisor-service';
import { APIWorkshopService } from 'src/services/api-services/api-workshop.service';
import { APIRepresentativeService } from 'src/services/api-services/api-representative-service';
import { APIService } from 'src/services/api-services/api-service';
import { APIServiceSchedule } from 'src/services/api-services/api-service-schedule';
import { APICustomScheduleService } from 'src/services/api-services/api-custom-schedule-service';
import { APIServiceDealer } from 'src/services/api-services/api-service-dealer';
import { APIServiceAdvisorBlockedSchedule } from '../../../../services/api-services/api-advisor-blocked-schedule-service';
import { APIDealerBlockedServices } from 'src/services/api-services/api-dealer-blocked-services';
import { APIAttentionSchedule } from '../../../../services/api-services/api-service-attention-schedule';
import { APIChannelOriginService } from 'src/services/api-services/api-channel-origin.service';
import { APIDocumentTypeService } from 'src/services/api-services/api-document-type.service';
import { APIVehicleRelationship } from 'src/services/api-services/api-vehicle-relationship.service';
import { VehicleRelationship } from 'src/services/api-services/api-interfaces/vehicleRelationship.interface';
import { HelperService } from 'src/services/helperService';
import { APIAdvisorsService } from 'src/services/api-services/api-advisors.service';
import { CreateSchedulerData } from 'src/services/api-services/api-interfaces/api-interface-create-scheduler';
import { APITermsAndPolitics } from 'src/services/api-services/api-terms-and-politics.service';
import { ScheduleStateService } from 'src/services/scheduleStateService.service';
import moment from 'moment';
import mileagesData from 'src/assets/mileagesData';
import DocumentType from 'src/services/api-services/api-interfaces/documentType.interface';
import { TranslateService } from '@ngx-translate/core';
import { unavaibleAdvisorHours } from '../../../../services/api-services/api-interfaces/unavaibleAdvisorHours.interface';
import { PersonType } from 'src/services/api-services/api-interfaces/customerBasicData.interface';
import { VehicleDataService } from 'src/services/api-services/vehicleData-service';

// TODO: Move this to a separate file
const noSpecialCharsValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const noSpecialChars = /^[^*=,\/#!$%\^\*;:{}\[\]~()<>\?|]+$/;
  const forbidden = !noSpecialChars.test(control.value);
  return forbidden ? {'noSpecialChars': {value: control.value}} : null;
};
const emailValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  const forbidden = !emailPattern.test(control.value);
  return forbidden ? {'invalidEmail': {value: control.value}} : null;
};

const numbersOnlyValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const invalid = /[^0-9]/.test(control.value);
  return invalid ? {'numbersOnly': {value: control.value}} : null;
};

interface schedule{
  customAdvisorSchedule?: any[],
  serviceAdvisorBlockedServices?: any[],
  serviceAdvisorScheduleDTO?: any[]
}

interface ScheduleData {
  typesOfServices: any[];
  availableWorkShops: any[];
}

@Component({
    selector: 'app-reschedule-appointment',
    templateUrl: './reschedule-appointment.dialog.html',
    styleUrls: ['./reschedule-appointment.dialog.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        TitleCasePipe,
        { provide: MAT_DATE_LOCALE, useValue: 'es-CO' },
        { provide: DateAdapter, useClass: CustomDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    ],
    standalone: false
})

export class RescheduleAppointmentDialog implements OnInit {

  advisorAttentionSchedule: any[] = [];
  advisorBlockedSchedules: any[] = [];
  allServices: any[] = [];
  appointmentSchedule;
  availableAdvisorHours: any[] = []
  availableAdvisors;
  availableWorkshops;
  blockedDays: any[] = [];
  countryBrandRetaildIdSelected;
  currentUserRoleId = Number(this.helperService.user.role.roleId)
  customerIdRole1;
  data$?: Observable<any>;
  error?: string;
  initialScheduleData$?: Observable<ScheduleData>;
  isSaving = false;
  loadingData = false;
  loDeBloquear: Date[] = [];
  loDeBloquearAdvisor: Date[] = [];
  mileages;
  selectedAdvisor: any;
  selectedAdvisorSchedules: any[] = [];
  termsAndpoliticsLink: string = "";
  typeOfServices: any[] = [];
  vechicleIdRole1;
  workshopBlockedSchedule: any[] = [];
  preselectedDate:any;
  selectedChannelName: any;
  isPopulatingFields = true;
  currentLanguage;
  countryId= Number(this.helperService.user.countryId)
  // Edit button on top of the html for owner
  isEditingOwner= false;
  editButton= false;
  isEditable= false;
  charCount: number = 0;
  documentName: string = "";
  showLastName: boolean = true;
  companyType: string = ''
  // Used when a customer is found These are filled in the "forkJoin" function
  customerDocumentTypeName: string | "" | undefined;
  customerPersonTypeName: string | "" | undefined;
  customerVehicleRelationShipName: string | "" | undefined;
 YearsShow = Array.from(
  { length: new Date().getFullYear() + 2 - 2000 },
  (_, i) => (2000 + i).toString()
).reverse(); 
  modelVehicle:any[]=[]
 personTypes: PersonType[] = [];
  EnableVehicleandModel = false
  documentTypesByPersonType: any[] = [];
  representativeDocumentTypes: any[] = [];
  // reschedule form
  reScheduleForm = this.fb.group({
    owner: this.fb.group({
      nombres: [this.appointment.clientFirstName, [ Validators.required, noSpecialCharsValidator ]],
      apellidos: [this.appointment.clientLastName, [ Validators.required, noSpecialCharsValidator ]],
      tipoDePersona: [this.appointment.personTypeId, Validators.required],
      tipoDeDocumento: [Number(this.appointment.typeOfDocument), Validators.required],
      numeroDeDocumento: [this.appointment.documentNumber, [ Validators.required ]],
      relacionClienteVehiculo: [Number(this.appointment.relationVC), Validators.required],
      celular: [this.appointment.contactNumber, [ Validators.required, numbersOnlyValidator ]],
      email: [ this.appointment.email, [ Validators.required,  emailValidator,noSpecialCharsValidator ]],
      placa: [this.appointment.plateNo, [ Validators.required, Validators.minLength(5)]],
      vin: [this.appointment.vinNo],
      año:[this.appointment.modelYear, [ Validators.required ]],
      model:[this.appointment.modelDescription, [ Validators.required ]],
    }),
    schedule: this.fb.group({
      marca: [Number(this.appointment.brandId)],
      ciudad: [this.appointment.cityId],
      tipoDeServicio: [{value:this.appointment.serviceId, disabled:true}],
      taller: [this.appointment.workshopId],
      asesor: [this.appointment.advisser ],
      kilometraje: [this.appointment.kilometraje],
      fecha: [{value:"", disabled: true},Validators.required],
      hora: [{value:"", disabled:true}, Validators.required],
      observacion: [""],
    }),
    representative: this.fb.group({
      duenoSePresentara: true,
      nombresRepresentante: [""],
      apellidosRepresentante: [""],
      tipoDeDocumentoRepresentante: [""],
      numeroDeDocumentoRepresentante: [""],
      celularRepresentante: [""],
      emailRepresentante: [""],
      representativeId:[0]
    }),
    termsAndPolitics: this.fb.group({
      terminos: [false, [Validators.required, Validators.requiredTrue]],
      politicas: [false,],
      DataPeru:[false]
    })
  })
  EditOwnerStyleButton:string="dialog__toggle-button"
  UpdateOwnerStyleButton:string="dialog__toggle-button"
  dateRangeReschedulerAdvisor
  /**
   *
   * @param initialTime is 24h format
   * @param finalTime is 24h format
   * @param unavailableHours unavailable hours of the advisor (scheduled hours)
   * @returns an array of available hours based on the initial time final time and unavailable hours of the advisor
   *
  */

  constructor(
    public dialogRef: MatDialogRef<SchedulingComponent>,
    @Inject(MAT_DIALOG_DATA) public appointment: any,
    public titleCasePipe: TitleCasePipe,
    public customerbasicdataService: APICustomerBasicDataService,
    public vehicleDataService: VehicleDataService,
    public schedulerService: APISchedulerService,
    public ServiceAdvisorApi: APIServiceAdvisorService,
    public WorkshopService: APIWorkshopService,
    public RepresentativeServiceApi: APIRepresentativeService,
    public Service: APIService,
    public ServiceSchedule: APIServiceSchedule,
    public customScheduleService: APICustomScheduleService,
    public serviceAdvisorBlockedSchedule: APIServiceAdvisorBlockedSchedule,
    public ServiceDealer: APIServiceDealer,
    public dealerBlockedService: APIDealerBlockedServices,
    private serviceAttentionService: APIAttentionSchedule,
    private fb: FormBuilder,
    public channelOriginService: APIChannelOriginService,
    public typeOfDocumentService: APIDocumentTypeService,
    public VehicleRelationshipService: APIVehicleRelationship,
    public helperService: HelperService,
    public advisorService: APIAdvisorsService,
    public termAndPoliticsService: APITermsAndPolitics,
    public scheduleStateService: ScheduleStateService,
    private translate: TranslateService,
  ) {
  }

  DateLengthWorkshop:any =undefined
  ngOnInit(): void {
    this.serchModels()
    // schedule date formated for the template
    this.currentLanguage = this.helperService.user.language;
    this.appointmentSchedule = this.titleCasePipe.transform(`${new Date(this.appointment.EventStart).
      toLocaleDateString(this.helperService.user.language, { weekday: 'long', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true })} -
      ${new Date(this.appointment.EventEnd).toLocaleTimeString(this.helperService.user.language, { hour: 'numeric', minute: 'numeric', hour12: true })}`);
    /*
      * Wait for all the calls to the backend to be completed
      * with "tap" get the name of the resource, its needed for "document type name" and "vehicle relationship name"
      * because you need a string not an id if the user is found
    */
    let observables: any = {
      channels: this.channelOriginService.getAllChannels().pipe(),
      personTypes: this.typeOfDocumentService
        .GetPersonTypeByCountryId(this.helperService.user.countryId)
        .pipe(
          catchError((error: any) => {
            if (error.status === 401) this.helperService.logoutToken();
            return throwError(() => error);
          })
        ),
      vehicleRelationships: this.VehicleRelationshipService.getAllVehicleRelationships().pipe(/*...*/),
    };

    if(this.appointment.representativeId > 0  && this.appointment.ownerOnSite == false){

      observables.representativeData= this.RepresentativeServiceApi.get(this.appointment.representativeId)
    }

    if (this.currentUserRoleId === 1) {
      // id of the current user not the advisor selected for the appointment
      observables.appointments = this.customScheduleService.getSchedulerByAdvisor(this.helperService.user.advisorId)
      
  
      observables.allServices = this.Service.getAdvisorServicesForServiceAdvisorRol(this.helperService.user.advisorId)
      observables.termsAndPolitics = this.termAndPoliticsService.termsAndPoliticsByBrandAndCountryId(Number(this.appointment.brandId),this.helperService.user.countryId)
    }

    if (this.currentUserRoleId === 2 || this.currentUserRoleId === 6) {
   
      observables.advisors = this.customScheduleService.getScheduleDropDownLists( this.currentUserRoleId, this.helperService.user.workshopId )
      observables.countryBrandRetaildId = this.WorkshopService.getCountryBrandRetailIdByBrandAndWorkshopId( Number(this.appointment.brandId), this.helperService.user.workshopId).pipe(tap((response)=> { this.DateLengthWorkshop= response[0] }))
      observables.termsAndPolitics = this.termAndPoliticsService.termsAndPoliticsByBrandAndCountryId(Number(this.appointment.brandId),this.helperService.user.countryId)
    }

    if(this.currentUserRoleId == 3 || this.currentUserRoleId === 4){
 
      observables.termsAndPolitics = this.termAndPoliticsService.termsAndPoliticsByBrandAndCountryId(Number(this.appointment.brandId),this.helperService.user.countryId)
    }

    this.data$ = forkJoin(observables).pipe(
      tap((results: any) => {
        if(results.representativeData && !("message" in results.representativeData)){

          const {documentType, email, firstName, identification, lastName, phone, representativeId } = results.representativeData;

          this.reScheduleForm.get("representative.duenoSePresentara")!.setValue(false)
          this.reScheduleForm.get("representative.nombresRepresentante")!.setValue(firstName)
          this.reScheduleForm.get("representative.apellidosRepresentante")!.setValue(lastName)
          this.reScheduleForm.get("representative.tipoDeDocumentoRepresentante")!.setValue(documentType)
          this.reScheduleForm.get("representative.numeroDeDocumentoRepresentante")!.setValue(identification)
          this.reScheduleForm.get("representative.celularRepresentante")!.setValue(phone)
          this.reScheduleForm.get("representative.emailRepresentante")!.setValue(email)
          this.reScheduleForm.get("representative.representativeId")!.setValue(representativeId)

        }        
        this.personTypes = results.personTypes ?? [];        
        this.updateLastNameVisibility(Number(this.tipoDePersona?.value)); 
        const personTypeId = this.reScheduleForm.get('owner.tipoDePersona')?.value;
        this.loadDocumentTypesByPersonType(Number(personTypeId));
        this.loadRepresentativeDocumentTypes();
        const vehicleRelationShip: VehicleRelationship | undefined = results.vehicleRelationships.find((document) => document.relationshipVehicleId === Number(this.appointment.relationVC))
        this.customerVehicleRelationShipName = vehicleRelationShip?.relationshipName;

        this.reScheduleForm.get('owner.tipoDePersona')?.valueChanges
          .pipe(
            tap((id) => this.updateLastNameVisibility(Number(id))),
            tap((personTypeId) => this.updateLastNameVisibility(Number(personTypeId))),
            filter(() => this.isEditingOwner === true),
            tap(() => {
              this.reScheduleForm.get('owner.tipoDeDocumento')?.reset(null);
              this.documentTypesByPersonType = [];
            }),
            switchMap((personTypeId: any) => {
              if (!personTypeId) return of([]);
              return this.typeOfDocumentService.GetDocumentTypeByCountryIdByPersonId(
                this.helperService.user.countryId,
                Number(personTypeId)
              ).pipe(
                catchError((error: any) => {
                  if (error.status === 401) this.helperService.logoutToken();
                  console.error('Validation Error:', error);
                  return of([]);
                })
              );
            })
          )
          .subscribe((docs: any[]) => {
            this.documentTypesByPersonType = docs ?? [];
          });

        if (this.currentUserRoleId === 1) {
          const appointments = results.appointments;
          this.selectedAdvisorSchedules = appointments.customAdvisorSchedule;
          this.advisorBlockedSchedules = appointments.serviceAdvisorBlockedServices;
          this.advisorAttentionSchedule = appointments.serviceAdvisorScheduleDTO;
          this.customerIdRole1 = this.appointment.customerId
          this.vechicleIdRole1 = this.appointment.vehicleId
          this.workshopBlockedSchedule = appointments.blockedservicesByServiceAdvisor;
          this.typeOfServices = results.allServices
          this.tipoDeServicio?.enable()

        //  this.setBlocksByWorkshopAndServiceSelected();
        // this.setBlocksByAdvisorAndServiceSelected();
        if(results.termsAndPolitics){
          if(results.termsAndPolitics[0]?.UrlAddress){
            this.termsAndpoliticsLink = results.termsAndPolitics[0].UrlAddress;
          }
          else{
            this.termsAndpoliticsLink = ""
          }}
          // get the name of the selected channel
          this.selectedChannelName = results.channels.find(channel => channel.originId === this.appointment.originId).originName;

          // populate schedule the fields
          this.populateServiceAdvisor();
        }
        if (this.currentUserRoleId === 2 || this.currentUserRoleId === 6) {

          const appointments = results.appointments;
          this.availableAdvisors = results.advisors
          this.customerIdRole1 = this.appointment.customerId
          this.vechicleIdRole1 = this.appointment.vehicleId
          this.countryBrandRetaildIdSelected = results.countryBrandRetaildId[0].countryBrandRetailId;
          if(results.termsAndPolitics){
          if(results.termsAndPolitics[0]?.UrlAddress){
            this.termsAndpoliticsLink = results.termsAndPolitics[0].UrlAddress;
          }
          else{
            this.termsAndpoliticsLink = ""
          }}
          // get the name of the selected channel
          this.selectedChannelName = results.channels.find(channel => channel.originId === this.appointment.originId).originName;

          this.populateDataWorkshop();
          // let advisorSelected = this.availableAdvisors.find(advisor => advisor.advisorFullName === this.appointment.advisor)
          // this.reScheduleForm.get("schedule.asesor")?.setValue(advisorSelected?.advisorId)

        }

        if(this.currentUserRoleId === 3 || this.currentUserRoleId === 4){
          this.customerIdRole1 = this.appointment.customerId
          this.vechicleIdRole1 = this.appointment.vehicleId

          if(results.termsAndPolitics){
          if(results.termsAndPolitics[0]?.UrlAddress){
            this.termsAndpoliticsLink = results.termsAndPolitics[0].UrlAddress;
          }
          else{
            this.termsAndpoliticsLink = ""
          }}
          this.selectedChannelName = results.channels.find(channel => channel.originId === this.appointment.originId).originName;

          // populate data
          this.populateDataContactCenter()
        }


      })
    );



    // SERVICE ADVISOR
    if(this.currentUserRoleId === 1){

      // Validators
      this.reScheduleForm.get("schedule.tipoDeServicio")?.setValidators(Validators.required)
      this.reScheduleForm.get("schedule.kilometraje")?.setValidators([Validators.required, numbersOnlyValidator, noSpecialCharsValidator])

      //* Type of service Changes
      this.reScheduleForm.get('schedule')?.get('tipoDeServicio')?.valueChanges
      .pipe(
        filter(() => this.isPopulatingFields == false)
      )
      .subscribe(serviceSelected => {
        this.reScheduleForm.get("schedule")?.get("fecha")?.setValue("");
        this.setBlocksByWorkshopAndServiceSelected();
        this.setBlocksByAdvisorAndServiceSelected();
        this.fecha?.enable()
      })

      //* Dates changes
      this.reScheduleForm.get('schedule')?.get('fecha')?.valueChanges
      .pipe(
        filter(() => this.isPopulatingFields == false)
      )
      .subscribe(dateSelected => {
        this.reScheduleForm.get("schedule")?.get("hora")?.setValue("");
        this.setAvailableHours(dateSelected)
        this.hora?.enable()
      })

    }
    // -- FIN DE SERVICE ADVISOR

    this.reScheduleForm.get('owner.tipoDePersona')?.valueChanges
      .pipe(
        filter(() => this.isEditingOwner === true),  
        tap(() => {
          
          this.reScheduleForm.get('owner.tipoDeDocumento')?.reset(null);
          this.documentTypesByPersonType = [];
        }),
        switchMap((personTypeId: any) => {
          if (!personTypeId) return of([]);
          return this.typeOfDocumentService.GetDocumentTypeByCountryIdByPersonId(
            this.helperService.user.countryId,
            Number(personTypeId)
          ).pipe(
            catchError((error: any) => {
              if (error.status === 401) this.helperService.logoutToken();
              console.error('Validation Error:', error);
              return of([]);
            })
          );
        })
      )
      .subscribe((docs: any[]) => {
        this.documentTypesByPersonType = docs ?? [];
      });

    // WORKSHOP
    if(this.currentUserRoleId == 2 || this.currentUserRoleId === 6){

      // add Validators
      this.reScheduleForm.get("schedule.asesor")?.setValidators(Validators.required)
      this.reScheduleForm.get("schedule.tipoDeServicio")?.setValidators(Validators.required)
      this.reScheduleForm.get("schedule.kilometraje")?.setValidators([Validators.required, numbersOnlyValidator, noSpecialCharsValidator])

      this.reScheduleForm.get('schedule')?.get('asesor')?.valueChanges
      .pipe(
        filter(() => this.isPopulatingFields === false),
        tap(advisor => {
          this.reScheduleForm.get("schedule.tipoDeServicio")?.setValue("")
        }),
        switchMap(advisorSelected => {
          // First HTTP request to get advisor schedule
          return this.customScheduleService.getSchedulerByAdvisor(advisorSelected)
            .pipe(
              tap((days:any) => {
                this.workshopBlockedSchedule = days.blockedservicesByServiceAdvisor
                this.advisorAttentionSchedule = days.serviceAdvisorScheduleDTO;
                this.selectedAdvisorSchedules = days.customAdvisorSchedule
                this.advisorBlockedSchedules = days.serviceAdvisorBlockedServices;
              }),
              // Second HTTP request to get available services
              switchMap(() => {
                // Get services
                return this.customScheduleService.getScheduleDropDownLists(
                  this.currentUserRoleId,
                  this.helperService.user.workshopId,
                  advisorSelected
                );
              }), catchError((error: any) => {
                // Handle validation error here
                console.error('Validation Error:', error);
                // Rethrow the error to propagate it downstream
                return throwError(error);
              })
            );
        })
      )
      .subscribe(availableServices => {

        this.typeOfServices = availableServices
        this.tipoDeServicio?.enable()
      });

      this.reScheduleForm.get('schedule')?.get('tipoDeServicio')?.valueChanges
      .pipe(
        filter(() => this.isPopulatingFields === false),
        tap(() => {
          if(this.reScheduleForm.get("schedule.tipoDeServicio")?.value == ""){
            this.reScheduleForm.get('schedule.fecha')?.disable();
          }
        }),
        filter(() => this.reScheduleForm.get('schedule.tipoDeServicio')?.value !== ""),
      )
      .subscribe(serviceSelected => {

        if( this.reScheduleForm.get('schedule.tipoDeServicio')?.value !== "" ){
          // Add blocks to be used to block dates in the matCalendar calendar
          this.setBlocksByWorkshopAndServiceSelected();
          this.setBlocksByAdvisorAndServiceSelected();

          this.fecha?.enable()
        }
      })

     this.reScheduleForm.get('schedule')?.get('fecha')?.valueChanges
     .pipe(
        filter(() => this.isPopulatingFields === false),
      )
      .subscribe(dateSelected => {
        this.reScheduleForm.get('schedule.hora')!.reset("");
        this.setAvailableHours(dateSelected)
        if(this.reScheduleForm.get('schedule.fecha')?.disabled == true){
          this.hora?.disable()
        }
        if(this.reScheduleForm.get('schedule.fecha')?.disabled == false){
          this.hora?.enable()
        }
      })


    }
    // -- FIN DE WORKSHOP


    // CONTACT CENTER
    if (this.currentUserRoleId === 3 || this.currentUserRoleId === 4) {

      let secondParameter= this.currentUserRoleId === 3 ? this.helperService.user.countryId : this.helperService.user.retailId;

      // add Validators
      this.reScheduleForm.get("schedule.tipoDeServicio")?.setValidators(Validators.required)
      this.reScheduleForm.get("schedule.taller")?.setValidators(Validators.required)
      this.reScheduleForm.get("schedule.asesor")?.setValidators(Validators.required)
      this.reScheduleForm.get("schedule.kilometraje")?.setValidators([Validators.required, numbersOnlyValidator, noSpecialCharsValidator])

      // Type of service changes => get workshops
      this.reScheduleForm.get('schedule')?.get('tipoDeServicio')?.valueChanges
      .pipe(
        filter(() => this.isPopulatingFields === false),
        switchMap((serviceSelectedId): Observable<any> => {
          return this.customScheduleService.getScheduleDropDownLists(
            this.currentUserRoleId,
            secondParameter,
            Number(this.appointment.brandId),
            this.appointment.cityId,
            serviceSelectedId as number
          )
        }),
      )
      .subscribe((availableWorkshops) => {

        this.availableWorkshops = availableWorkshops;
        this.reScheduleForm.get("schedule.taller")?.reset("")
      });

      // Workshop changes => get advisors
      this.reScheduleForm.get('schedule')?.get('taller')?.valueChanges
      .pipe(
        filter(() => this.isPopulatingFields === false),
        switchMap((workshopSelected): Observable<any> => {
          return this.customScheduleService.getScheduleDropDownLists(
            this.currentUserRoleId,
            secondParameter,
            Number(this.appointment.brandId),
            this.appointment.cityId,
            this.reScheduleForm.get('schedule')?.get('tipoDeServicio')!.value,
            workshopSelected
          )
        }),
      )
      .subscribe((availableAdvisors) => {

        this.availableAdvisors = availableAdvisors;
        this.reScheduleForm.get("schedule.asesor")?.reset("")

      });

      // Advisor changes => get advisor schedule
      this.reScheduleForm.get('schedule')?.get('asesor')?.valueChanges
      .pipe(

        filter(() => {
          this.isPopulatingFields === false

          this.reScheduleForm.get('schedule.fecha')!.disable();
          this.reScheduleForm.get('schedule.hora')?.disable();
          return this.reScheduleForm.get("schedule.asesor")?.value != ""
        }),
        switchMap((advisorSelected:any) => {
          return this.customScheduleService.getSchedulerByAdvisor(advisorSelected)

        }),
        tap((blocksAndSchedule:any) => {
          this.workshopBlockedSchedule = blocksAndSchedule.blockedservicesByServiceAdvisor
          this.advisorBlockedSchedules = blocksAndSchedule.serviceAdvisorBlockedServices
          // estas son las citas usadas para las horas, pero seteadas de una vez.
          this.selectedAdvisorSchedules = blocksAndSchedule.customAdvisorSchedule
          this.advisorAttentionSchedule = blocksAndSchedule.serviceAdvisorScheduleDTO
          this.reScheduleForm.get('schedule.fecha')?.enable();
          this.reScheduleForm.get('schedule.hora')?.enable();
          // check if the advisor has a attention schedule
          // if(this.advisorAttentionSchedule.length <= 0){
          //   throw new Error("El asesor no tiene configurado horarios")
          // }

          // Add blocks to be used to block dates in the matCalendar calendar
          this.setBlocksByWorkshopAndServiceSelected();
          this.setBlocksByAdvisorAndServiceSelected();

        })
      )
      .subscribe((selectedAdvisor) => {
        if(this.reScheduleForm.get("schedule.asesor")?.value !== ""){
          this.reScheduleForm.get('schedule.fecha')?.enable();
        }
      });

      // Date changes => get advisor available hours
      this.reScheduleForm.get('schedule')?.get('fecha')?.valueChanges
      .pipe(
        filter(() => this.isPopulatingFields === false),
        // Case there is an error or the date is empty
        filter((date) => date != ""),
      )
      .subscribe(dateSelected => {
        this.hora?.enable()
        this.reScheduleForm.get('schedule.hora')!.reset("");
        this.setAvailableHours(dateSelected)
      })


    }
    // -- FIN CONTACT CENTER


    // is owner present?
    this.reScheduleForm.get("representative")?.get("duenoSePresentara")?.valueChanges.subscribe( isOwnerPresent => {
      if(isOwnerPresent == false){
        this.reScheduleForm.get("representative.nombresRepresentante")?.setValidators([Validators.required, noSpecialCharsValidator])
        this.reScheduleForm.get("representative.apellidosRepresentante")?.setValidators([Validators.required, noSpecialCharsValidator])
        this.reScheduleForm.get("representative.tipoDeDocumentoRepresentante")?.setValidators([Validators.required])
        this.reScheduleForm.get("representative.numeroDeDocumentoRepresentante")?.setValidators([Validators.required])
        this.reScheduleForm.get("representative.celularRepresentante")?.setValidators([Validators.required, numbersOnlyValidator])
        this.reScheduleForm.get("representative.emailRepresentante")?.setValidators([Validators.required, Validators.email])
      }
      else{
        // Its necessary to repeat the code like this
        // clearing validators do not propagate to child elements of the form.
        this.reScheduleForm.get("representative")?.clearValidators();
        this.reScheduleForm.get("representative.nombresRepresentante")?.clearValidators()
        this.reScheduleForm.get("representative.nombresRepresentante")?.updateValueAndValidity();
        this.reScheduleForm.get("representative.apellidosRepresentante")?.clearValidators()
        this.reScheduleForm.get("representative.apellidosRepresentante")?.updateValueAndValidity()
        this.reScheduleForm.get("representative.tipoDeDocumentoRepresentante")?.clearValidators()
        this.reScheduleForm.get("representative.tipoDeDocumentoRepresentante")?.updateValueAndValidity()
        this.reScheduleForm.get("representative.numeroDeDocumentoRepresentante")?.clearValidators()
        this.reScheduleForm.get("representative.numeroDeDocumentoRepresentante")?.updateValueAndValidity()
        this.reScheduleForm.get("representative.celularRepresentante")?.clearValidators()
        this.reScheduleForm.get("representative.celularRepresentante")?.updateValueAndValidity()
        this.reScheduleForm.get("representative.emailRepresentante")?.clearValidators()
        this.reScheduleForm.get("representative.emailRepresentante")?.updateValueAndValidity()
      }
      this.reScheduleForm.get("representative")?.updateValueAndValidity();
    })


  }
  // -- FIN ON INIT

  // Initial data for ROLE
  populateServiceAdvisor(){

    this.reScheduleForm.get("schedule.fecha")?.enable()
    this.reScheduleForm.get("schedule.hora")?.enable()

    this.WorkshopService.getCountryBrandRetailIdByBrandAndWorkshopId( Number(this.appointment.brandId) ,this.helperService.user.workshopId)
    .subscribe(data => {
      this.countryBrandRetaildIdSelected = data[0].countryBrandRetailId;
      this.dateRangeReschedulerAdvisor = data[0].dateLength
      this.setAvailableHours(this.fecha?.value)
    })
    let serviceSelected = this.typeOfServices.find(service => service.serviceName === this.appointment.typeOfService);
    this.reScheduleForm.get("schedule")?.get("tipoDeServicio")?.setValue(serviceSelected.serviceId);
    this.setBlocksByWorkshopAndServiceSelected();
    this.setBlocksByAdvisorAndServiceSelected();
    this.reScheduleForm.get("schedule")?.get("kilometraje")?.setValue(this.appointment.kilometraje);
    this.reScheduleForm.get("schedule")?.get("fecha")?.setValue(new Date(this.appointment.EventStart).toISOString());
    this.reScheduleForm.get("schedule")?.get("observacion")?.setValue(this.appointment.observations);
    const dateStr = new Date(this.appointment.EventStart).toISOString();
    const date = new Date(dateStr);
    const timeStr = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
    this.reScheduleForm.get("schedule")?.get("hora")?.setValue(timeStr);
    this.isPopulatingFields = false;
  }

  populateDataWorkshop(){
    // all advisors are already loaded from the fork join
    let serviceSelected:any = "";
    let advisorSelected: any = "";
    this.reScheduleForm.get("schedule.tipoDeServicio")?.enable();
    this.reScheduleForm.get("schedule.fecha")?.enable();
    this.reScheduleForm.get("schedule.hora")?.enable();

    advisorSelected = this.availableAdvisors.find(advisor => advisor.advisorFullName === this.appointment.advisor)

    if(advisorSelected === undefined){
      console.warn("El asesor original para la cita no se encuentra entre lista de asesores del taller, se deja el formulario en blanco!");
      this.isPopulatingFields = false;
      return;
    }

    this.reScheduleForm.get("schedule")?.get("asesor")?.setValue(advisorSelected.advisorId);

    // Services need to be loaded first
    this.customScheduleService.getScheduleDropDownLists(
      this.currentUserRoleId,
      this.helperService.user.workshopId,
      advisorSelected.advisorId,
    )
    .pipe(
      switchMap((availableServices) =>{
        this.typeOfServices = availableServices;
        serviceSelected = this.typeOfServices.find(service => service.serviceName === this.appointment.typeOfService);
        this.reScheduleForm.get("schedule.tipoDeServicio")?.setValue(serviceSelected.serviceId);
        return of(this.typeOfServices)
      }),catchError((error: any) => {
        // Handle validation error here
        if(error.status === 401){
          this.helperService.logoutToken()
        }
        console.error('Validation Error:', error);
        // Rethrow the error to propagate it downstream
        return throwError(error);
      })
    )
    .subscribe(availableServices => {
    })

    this.customScheduleService.getSchedulerByAdvisor(this.reScheduleForm.get("schedule.asesor")?.value)
    .pipe(
      tap((blocksAndSchedule:any) => {
        this.workshopBlockedSchedule = blocksAndSchedule.blockedservicesByServiceAdvisor
        this.advisorBlockedSchedules = blocksAndSchedule.serviceAdvisorBlockedServices
        // estas son las citas usadas para las horas, pero seteadas de una vez.
        this.selectedAdvisorSchedules = blocksAndSchedule.customAdvisorSchedule
        this.advisorAttentionSchedule = blocksAndSchedule.serviceAdvisorScheduleDTO

        // Add blocks to be used to block dates in the matCalendar calendar
        this.setBlocksByWorkshopAndServiceSelected();
        this.setBlocksByAdvisorAndServiceSelected();
        // Date needs to bet set here so the hours work correctly
        this.reScheduleForm.get('schedule.fecha')?.setValue(new Date(this.appointment.EventStart).toISOString());
      }), catchError((error: any) => {
        // Handle validation error here
        if(error.status === 401){
          this.helperService.logoutToken()
        }
        console.error('Validation Error:', error);
        // Rethrow the error to propagate it downstream
        return throwError(error);
      })
    )
    .subscribe((availableServices) => {
      let dateSelected:any = this.reScheduleForm.get("schedule.fecha")?.value;
      this.setAvailableHours(dateSelected)
      this.reScheduleForm.get('schedule.observacion')!.setValue(this.appointment.observations);
      const date = new Date(this.appointment.EventStart);
      const timeStr = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
      this.reScheduleForm.get('schedule.hora')!.setValue(timeStr);
      this.isPopulatingFields = false;
    })

  }

   populateDataContactCenter(){

    this.tipoDeServicio?.enable();
    this.fecha?.enable();
    this.hora?.enable();
    let secondParameter= this.currentUserRoleId === 3 ? this.helperService.user.countryId : this.helperService.user.retailId;


    this.customScheduleService.getScheduleDropDownLists( this.currentUserRoleId, secondParameter, Number(this.appointment.brandId), this.appointment.cityId,)
    .pipe(filter(() => this.isPopulatingFields === true))
    .subscribe((availableServices) => {
      this.typeOfServices = availableServices;
      let serviceSelected = this.typeOfServices.find(service => service.serviceName === this.appointment.typeOfService);
      this.reScheduleForm.get('schedule.tipoDeServicio')!.setValue(serviceSelected.serviceId);
    })

    this.reScheduleForm.get("schedule.tipoDeServicio")?.valueChanges.pipe(
      filter(() => this.isPopulatingFields === true),
      switchMap((selectedService) => {
        return this.customScheduleService.getScheduleDropDownLists( this.currentUserRoleId,secondParameter,Number(this.appointment.brandId),this.appointment.cityId,selectedService)
      }),
    ).subscribe((workshops) => {
      this.availableWorkshops = workshops;
      this.reScheduleForm.get('schedule.taller')!.setValue(this.appointment.workshopId);
    })

    this.reScheduleForm.get("schedule.taller")?.valueChanges
    .pipe(
      filter(() => this.isPopulatingFields === true),
      switchMap((workshopSelected) => {
        return this.customScheduleService.getScheduleDropDownLists(
          this.currentUserRoleId,
          secondParameter,
          Number(this.appointment.brandId),
          this.appointment.cityId,
          this.reScheduleForm.get("schedule.tipoDeServicio")?.value,
          workshopSelected
        )
      }),
      filter((advisors)=>{
        this.availableAdvisors = advisors;
        let advisorSelected = this.availableAdvisors.find(advisor => advisor.advisorFullName === this.appointment.advisor);
        if(advisorSelected !== undefined){
          return true;
        }
        else{
          console.error("El asesor para la cita no esta en la lista de asesores del taller!")
          this.isPopulatingFields = false;
          this.reScheduleForm.get('schedule.fecha')!.disable();
         this.reScheduleForm.get('schedule.hora')?.disable();
          return false;
        }
      }),
      tap((advisors) =>{
        this.availableAdvisors = advisors;
        let advisorSelected = this.availableAdvisors.find(advisor => advisor.advisorFullName === this.appointment.advisor);
        this.reScheduleForm.get('schedule.asesor')!.setValue(advisorSelected.advisorId);
      }),
      catchError(err => {
        console.error("Error encontrando al asesor para la cita, no esta en la lista de asesores del taller", err);
        if(err.status === 401){
          this.helperService.logoutToken()
        }
        this.reScheduleForm.get('schedule.asesor')!.setValue("");
        this.isPopulatingFields = false;
        return of(null)
      }),
      switchMap(() => {
        return this.customScheduleService.getSchedulerByAdvisor(this.reScheduleForm.get("schedule.asesor")?.value)
      }),
      tap((blocksAndSchedule:any) =>{
        this.workshopBlockedSchedule = blocksAndSchedule.blockedservicesByServiceAdvisor
        this.advisorBlockedSchedules = blocksAndSchedule.serviceAdvisorBlockedServices
        // estas son las citas usadas para las horas, pero seteadas de una vez.
        this.selectedAdvisorSchedules = blocksAndSchedule.customAdvisorSchedule
        this.advisorAttentionSchedule = blocksAndSchedule.serviceAdvisorScheduleDTO

        // Add blocks to be used to block dates in the matCalendar calendar
        this.reScheduleForm.get('schedule.fecha')!.setValue(new Date(this.appointment.EventStart).toISOString());
        this.setBlocksByWorkshopAndServiceSelected();
        this.setBlocksByAdvisorAndServiceSelected();
      })
    )
    .subscribe((advisors) => {
      let dateSelected:any = this.reScheduleForm.get("schedule.fecha")?.value;
      this.setAvailableHours(dateSelected)
      this.reScheduleForm.get('schedule.observacion')!.setValue(this.appointment.observations);
      const date = new Date(this.appointment.EventStart);
      const timeStr = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
      this.reScheduleForm.get('schedule.hora')!.setValue(timeStr);
      this.isPopulatingFields = false;
    })

    this.reScheduleForm.get("schedule.fecha")?.valueChanges
      .pipe(
        filter(() => this.isPopulatingFields === true),
        tap((dateSelected) => {

          let date = new Date(this.appointment.EventStart);
          const timeStr = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });

          this.reScheduleForm.get('schedule.hora')!.setValue(timeStr);
        })
      )
      .subscribe(() =>{
        this.reScheduleForm.get('schedule.observacion')!.setValue(this.appointment.observations);
        this.isPopulatingFields = false;
      })

  }

  private loadDocumentTypesByPersonType(personTypeId: number | null | undefined): void {
    if (!personTypeId) {
      this.documentTypesByPersonType = [];
      this.reScheduleForm.get('owner.tipoDeDocumento')?.reset(null);
      return;
    }
    this.updateLastNameVisibility(personTypeId);
    this.typeOfDocumentService
      .GetDocumentTypeByCountryIdByPersonId(this.helperService.user.countryId, Number(personTypeId))
      .pipe(
        catchError((error: any) => {
          if (error.status === 401) this.helperService.logoutToken();
          console.error('Error loading document types:', error);
          this.documentTypesByPersonType = [];
          return of([]);
        })
      )
      .subscribe((docs: any[]) => {
        this.documentTypesByPersonType = docs ?? [];        
        const currentDoc = this.reScheduleForm.get('owner.tipoDeDocumento')?.value;
        const stillValid = this.documentTypesByPersonType.some(d => Number(d.typeId) === Number(currentDoc));

        if (!stillValid) {
          this.reScheduleForm.get('owner.tipoDeDocumento')?.reset(null);
        }
      });
  }

  private loadRepresentativeDocumentTypes(): void {
    const individualPersonType = this.personTypes.find(
      (p) => (p.typeLabel ?? '').trim().toLowerCase() === 'individual'
    );

    if (!individualPersonType?.typeId) {
      this.representativeDocumentTypes = [];
      return;
    }

    this.typeOfDocumentService
      .GetDocumentTypeByCountryIdByPersonId(
        this.helperService.user.countryId,
        Number(individualPersonType.typeId)
      )
      .pipe(
        catchError((error: any) => {
          if (error.status === 401) this.helperService.logoutToken();
          console.error('Error loading representative document types:', error);
          this.representativeDocumentTypes = [];
          return of([]);
        })
      )
      .subscribe((docs: any[]) => {
        this.representativeDocumentTypes = docs ?? [];
      });
  }

  private updateLastNameVisibility(personTypeId: number | null | undefined): void {
  const lastNameCtrl = this.reScheduleForm.get('owner.apellidos');
  const selected: PersonType | undefined = this.personTypes.find(
    p => Number(p.typeId) === Number(personTypeId)
  );

  const isCompany = (selected?.typeLabel ?? '').toLowerCase() === 'company';
  this.companyType = isCompany ? 'Company' : 'Individual';
  this.showLastName = !isCompany;

  if (isCompany) {    
    lastNameCtrl?.clearValidators();
    lastNameCtrl?.setValue('NaN');
    lastNameCtrl?.updateValueAndValidity({ emitEvent: false });
  } else {    
    lastNameCtrl?.setValidators([Validators.required, noSpecialCharsValidator]);
    if (lastNameCtrl?.value === 'NaN') lastNameCtrl?.setValue('');
    lastNameCtrl?.updateValueAndValidity({ emitEvent: false });
  }
}

//  edit owner data
  editOwnerAndChangeOwner(Status:number){
    switch (Status) {
      case 1:
        // Edit Data owner
        this.isEditable = false;
        this.isEditingOwner = true;
        this.EditOwnerStyleButton="dialog__toggle-button-select"
        this.UpdateOwnerStyleButton="dialog__toggle-button"
        this.reScheduleForm.get("owner")?.get('numeroDeDocumento')!.disable();
        this.reScheduleForm.get("owner")?.get('tipoDeDocumento')!.disable();
        this.reScheduleForm.get("owner")?.get("tipoDePersona")!.disable();
        this.loadDocumentTypesByPersonType(Number(this.tipoDePersona?.value));
      break;
      case 2:
        // Update Data owner
      this.reScheduleForm.get("owner")?.get('numeroDeDocumento')!.enable();
      this.reScheduleForm.get("owner")?.get('tipoDeDocumento')!.enable();
      this.reScheduleForm.get("owner")?.get("tipoDePersona")!.enable(); 
      this.reScheduleForm.get("owner")?.reset();
      this.reScheduleForm.get("owner")?.get("placa")?.setValue(this.appointment.plateNo)
      this.isEditingOwner = true;
      this.isEditable = false;
      this.UpdateOwnerStyleButton="dialog__toggle-button-select"
      this.EditOwnerStyleButton="dialog__toggle-button"
      this.customerIdRole1= 0;
      this.documentTypesByPersonType=[];

      break;

      case 3:
        // show tootip
      this.isEditable = !this.isEditable;
      break;
    }
  }

  serchModels(){
   // reset fields
   
    // this.loadingSerchPlate = true
   
    this.vehicleDataService
      .getValidatedDataWithCountryAndbrand(this.appointment.plateNo,Number(this.appointment.brandId),this.appointment.documentNumber)
      .pipe(
        tap((response) => {
          this.modelVehicle = response.vehicleModelInfo.models
          
          const model = response.vehicleModelInfo.modelDescription;
          this.documentName = response.typeName;
          this.EnableVehicleandModel = !!model && model.trim() !== "";
        }),

      )
      .subscribe({
        error: (error) => {
        
            console.log(error)
            const translateTxtNotMatch = this.translate.instant("Errorcharacters")
            this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTxtNotMatch
            setTimeout(() => {
              this.helperService.showAlert =false
            }, 7000)

            
             
    }});
  
}

 /**
   * Uses data that is set globally once the advisor changes
   * the "output" of the function is to give "createHoursArray" function a set of hours
   * format date as input recibed
   */
 setAvailableHours(dateSelected){

  this.availableAdvisorHours = [];

  let serviceNameSelected = this.getSelectedServiceName()

  this.availableAdvisorHours = [];
  let date: Date = new Date();

  date = new Date(dateSelected);


    // get the schedules of the day based on date
    let selectedDateSchedule = this.selectedAdvisorSchedules.filter((schedule) => {
      return new Date(schedule.start).getDate() === date.getDate() && new Date(schedule.start).getMonth() === date.getMonth() && new Date(schedule.start).getFullYear() === date.getFullYear()
    })

    // get "unavailable" hours --- scheduled hours
    let unavailableHours: any[] = [];

  // * get unavailable hours based on the scheduled dates
  // turn this = "2023-02-14T14:05:00.000Z" into "2:05 PM"
  selectedDateSchedule.forEach((schedule) =>{
    // format: 'Fri Feb 03 2023 10:00:00 GMT-0500';
    const intervals = this.getTimeIntervals(schedule.start, schedule.end);

    intervals.forEach( el => {
      unavailableHours.push(el);
    })

    // console.log("citas",schedule);


  });


  // From all the blocked services get the ones with the same name as the type of service selected
  let usableBlockedSchedules = this.advisorBlockedSchedules.filter( block => block.serviceName.toLowerCase() === serviceNameSelected.toLowerCase())

  // Now filter those to get the ones that have the same date as the one selected.
  usableBlockedSchedules = usableBlockedSchedules.filter(block => {
    const initialDate = new Date(block.initialDateBlockedServices);
    const finalDate = new Date(block.finalDateBlockedServices);
    const targetDate = new Date(date);
    return (initialDate <= targetDate && finalDate >= targetDate);
  });

  usableBlockedSchedules.forEach(block => {

    // turning the blocked schedule start and final time that comes like this "07:00:00" into something valid
    let validInitialHour = new Date();

    const [hours, minutes, seconds] = block.hourInitialBlockedServices.split(':');

    // Set the hours, minutes, and seconds of the validHour object
    validInitialHour.setHours(hours);
    validInitialHour.setMinutes(minutes);
    validInitialHour.setSeconds(seconds);

    let validFinalHour = new Date();
    const [hours2, minutes2, seconds2] = block.hourFinaBlockedServices.split(':');

    // Set the hours, minutes, and seconds of the validHour object
    validFinalHour.setHours(hours2);
    validFinalHour.setMinutes(minutes2);
    validFinalHour.setSeconds(seconds2);

    const intervals = this.getTimeIntervals(validInitialHour, validFinalHour);

    // intervals.forEach( el => {
    //   console.log(el);

    //   unavailableHours.push({
    //     name: "block",
    //     blockEnd: el.hourFinaBlockedServices,
    //     blockStart: el.hourInitialBlockedServices
    //   });
    // })

      unavailableHours.push({
        name: "block",
        blockEnd: block.hourFinaBlockedServices,
        blockStart: block.hourInitialBlockedServices
      });

  })

  // * Now check for the workshop blocked services or schedules
  // seleccionar los bloqueos que tengan el nombre = al servicio seleccionado y esten entre las 1:01 y las 23:29
  let workshopBlocksByTimeAndService = this.workshopBlockedSchedule.filter(block => {
    return block.serviceName === serviceNameSelected
  });

  // a partir del filtro anterior seleccionar los que esten en la fecha escogida-
  let workshopBlocksByDate = workshopBlocksByTimeAndService.filter( block => {
    return new Date(block.initialDate).toDateString() === new Date(block.finalDate).toDateString() && date.toDateString() === new Date(block.initialDate).toDateString()
  })


  workshopBlocksByDate.forEach( block => {

    // turning the blocked schedule start and final time that comes like this "07:00:00" into something valid
    let validInitialHour = new Date();

    const [hours, minutes, seconds] = block.hourInitial.split(':');

    // Set the hours, minutes, and seconds of the validHour object
    validInitialHour.setHours(hours);
    validInitialHour.setMinutes(minutes);
    validInitialHour.setSeconds(seconds);

    let validFinalHour = new Date();
    const [hours2, minutes2, seconds2] = block.hourFinal.split(':');

    // Set the hours, minutes, and seconds of the validHour object
    validFinalHour.setHours(hours2);
    validFinalHour.setMinutes(minutes2);
    validFinalHour.setSeconds(seconds2);


    const intervals = this.getTimeIntervals(validInitialHour, validFinalHour);

    intervals.forEach( el => {
      unavailableHours.push(el);
    })

  })




  // get the attention schedule based on the day of the week (number)
  let advisorAttentionScheduleForTheDay: any =this.advisorAttentionSchedule.find((attention) =>  Number(attention.dayNumber) === date.getDay())

  // console.log("horario", advisorAttentionScheduleForTheDay);
  // Now get from when to when he will be working based on the day
  if(!advisorAttentionScheduleForTheDay){
    console.error("Advisor has not attention hours configured for day", date.getDay());
  }
  let attentionStart =  advisorAttentionScheduleForTheDay.hourInitialAdvisorSchedule
  let attentionEnd =  advisorAttentionScheduleForTheDay.hourFinaAdvisorSchedule


  this.availableAdvisorHours = this.createHourArray(attentionStart, attentionEnd, unavailableHours);

}
  /**
   * Uses workshopBlockedSchedules that are set globaly once the advisor changes
   * the "output" of the function is to give "myFilter" function dates to block
   */
  setBlocksByWorkshopAndServiceSelected(){
    this.loDeBloquear = []
    // 1. BLOQUEaNDO POR TALLER Y TIPO DE SERVICIO - SOLO SE AGREGAN BLOQUEOS DE TODO EL DIA
    // las horas se agregan una vez se selecciona una fecha

    // tener todos los bloqueos del taller basado en el servicio seleccionado

    let serviceSelectedN = this.typeOfServices.find(service => service.serviceId === this.reScheduleForm.get("schedule")?.get("tipoDeServicio")?.value)
    let workshopBlockByServiceSelected = this.workshopBlockedSchedule.filter(block => block.serviceName === serviceSelectedN.serviceName)

    workshopBlockByServiceSelected.forEach(block => {
      // el bloqueo es para un solo dia??
      if (block.initialDate === block.finalDate) {

        // es de todo el dia el bloqueo? - ( como debe ser para este caso )
        if (block.hourInitial === "01:00:00" && block.hourFinal === "23:30:00") {
          let formatedBlockDate = new Date(block.initialDate)
          this.loDeBloquear.push(formatedBlockDate)
        }
      }
      // el bloqueo tiene un rango de dias
      else {
        let daysInRange = this.getMissingDays(block.initialDate, block.finalDate)

        // es de todo el dia el bloqueo ?
        if (block.hourInitial === "01:00:00" && block.hourFinal === "23:30:00") {

          daysInRange.forEach(day => {
            let nuevaFecha: Date = new Date()
            nuevaFecha.setFullYear(new Date(day).getFullYear())
            nuevaFecha.setMonth(new Date(day).getMonth())
            nuevaFecha.setDate(new Date(day).getDate())
            this.loDeBloquear.push(nuevaFecha);
          })
        }
      }
    })
  }

  /**
   * Uses advisorBlockedSchedules that are set globaly once the advisor changes
   * the "output" of the function is to give "myFilter" function dates to block
   */
  setBlocksByAdvisorAndServiceSelected(){
    this.loDeBloquearAdvisor=[]
    let serviceSelectedN = this.typeOfServices.find(service => service.serviceId === this.reScheduleForm.get("schedule")?.get("tipoDeServicio")?.value)
    // 1. BLOQUEANDO POR ASESOR Y TIPO DE SERVICIO - SOLO SE AGREGAN BLOQUEOS DE TODO EL DIA
    // las horas se agregan una vez se selecciona una fecha

    // tener todos los bloqueos del taller basado en el servicio seleccionado
    let advisorBlockByServiceSelected = this.advisorBlockedSchedules.filter(block => block.serviceName === serviceSelectedN.serviceName)
    advisorBlockByServiceSelected.forEach(block => {
      // el bloqueo es para un solo dia??
      if (block.initialDateBlockedServices === block.finalDateBlockedServices) {
        // es de todo el dia el bloqueo? - ( como debe ser para este caso )
        if (block.hourInitialBlockedServices === "01:00:00" && block.hourFinaBlockedServices === "23:30:00") {

          let formatedBlockDate = new Date(block.initialDate)
          this.loDeBloquearAdvisor.push(formatedBlockDate)
        }
      }
      // el bloqueo tiene un rango de dias
      else {

        let daysInRange = this.getMissingDays(block.initialDateBlockedServices, block.finalDateBlockedServices)
        // es de todo el dia el bloqueo ?
        if (block.hourInitialBlockedServices === "01:00:00" && block.hourFinaBlockedServices === "23:30:00") {

          daysInRange.forEach(day => {
            let nuevaFecha: Date = new Date()
            nuevaFecha.setFullYear(new Date(day).getFullYear())
            nuevaFecha.setMonth(new Date(day).getMonth())
            nuevaFecha.setDate(new Date(day).getDate())
            this.loDeBloquearAdvisor.push(nuevaFecha);
          })
        }
      }
    })
  }

  getMissingDays(initialDate: string, finalDate: string): string[] {
    // Convert input strings into Date objects
    const startDate = new Date(initialDate);
    const endDate = new Date(finalDate);

    // Calculate the number of days between the two dates
    const numDays = Math.floor((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)) + 1;

    // Create an array to store the missing days
    const missingDays: string[] = [];


    // Add the initial date to the array
    missingDays.push(startDate.toLocaleString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true }));


    // Loop through each day between the two dates and add it to the array
    for (let i = 1; i < numDays - 1; i++) {
      const currentDate = new Date(startDate.getTime() + (i * 24 * 60 * 60 * 1000));
      missingDays.push(currentDate.toLocaleString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true }));
    }

    // Add the final date to the array
    missingDays.push(endDate.toLocaleString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true }));

    return missingDays;
  }

  getAdvisorScheduleServiceAdvisorRol(advisorId) {

    // reset data just in case...
    this.selectedAdvisorSchedules = [];
    this.advisorAttentionSchedule = [];
    this.advisorBlockedSchedules = [];

    this.loadingData = true
    this.customScheduleService.getSchedulerByAdvisor(advisorId)
    .pipe(
      tap(() => {
        complete: () => {
          this.loadingData = true
        }
      }),catchError((error: any) => {
        // Handle validation error here
        console.error('Validation Error:', error);
        // Rethrow the error to propagate it downstream
        return throwError(error);
      })
    )
    .subscribe( (data:any) => {
      this.selectedAdvisorSchedules = data.customAdvisorSchedule;
      this.advisorBlockedSchedules = data.serviceAdvisorBlockedServices;
      this.advisorAttentionSchedule = data.serviceAdvisorScheduleDTO;
    })

  }

  getAdvisorSchedule(advisor:any){

    this.selectedAdvisorSchedules = [];
    this.advisorAttentionSchedule = [];
    this.advisorBlockedSchedules = [];

    if(advisor != undefined){

        this.advisorService.getAllAdvisors()
        .pipe(
          map(advisors => advisors.find(advisorFromServer => advisorFromServer?.advisorFullName === advisor?.advisorFullName)),
          switchMap(filteredAdvisor => {
            return this.customScheduleService.getSchedulerByAdvisor(filteredAdvisor?.advisorId);
          }),catchError((error: any) => {
            // Handle validation error here
            if(error.status === 401){
              this.helperService.logoutToken()
            }
            console.error('Validation Error:', error);
            // Rethrow the error to propagate it downstream
            return throwError(error);
          })
        )
        .subscribe((data:any) => {
          this.selectedAdvisorSchedules = data.customAdvisorSchedule;
          this.advisorAttentionSchedule = data.serviceAdvisorScheduleDTO;
          this.advisorBlockedSchedules = data.serviceAdvisorBlockedServices;
        });
    }

  }

  getSelectedServiceName(){
    let service = this.typeOfServices.find(service => service.serviceId === this.reScheduleForm.get("schedule")?.get("tipoDeServicio")?.value)
    if(service){
      return service.serviceName
    }
    return "";
  }

// Funcion create hour array

  generateHoursArray(hourInitial: string, hourFinal: string, interval:number): string[] {
    const hoursArray:any[] = [];
    let currentTime:any = hourInitial;

    const initialTime = new Date(`1970-01-01T${hourInitial}Z`);
    const finalTime = new Date(`1970-01-01T${hourFinal}Z`);

    while (initialTime < finalTime) {
      hoursArray.push(currentTime);
      const [hours, minutes, seconds] = currentTime.split(':');
      const currentDate = new Date(
        0,
        0,
        0,
        parseInt(hours),
        parseInt(minutes),
        parseInt(seconds)
      );
      currentDate.setMinutes(currentDate.getMinutes() + interval);
      currentTime = currentDate.toTimeString().slice(0, 8);
      initialTime.setMinutes(initialTime.getMinutes() + interval);
    }
    hoursArray.forEach((h) => {
      const timeMoment = moment(h, 'HH:mm:ss'); // Create a moment object from the input time
      const timeAmPm = timeMoment.format('hh:mm A');
    });
    return hoursArray;
  }

  createHourArray(advisorAttentionStart: string, advisorAttentionEnd: string, unavailableHours: any[]): string[] {
    let HourInitial = moment.duration(advisorAttentionStart).asHours();
  let HourFinal = moment.duration(advisorAttentionEnd).asHours()


    let hours: string[] = [];
    let DataRange = 0;

    // 1 HINO
    // 2 SUBARU
    // 3 DFSK
    // 4 BMW
    // 5 MINI
    // 6 MOTORAD
    // 7 BYD
    switch(this.helperService.user.countryId){
      // Colombia
      case 1:
        if(Number(this.appointment.brandId) === 2 ||Number(this.appointment.brandId) === 3){
          DataRange = 30;
        }
        if(Number(this.appointment.brandId) === 1){
          DataRange = 60;
        }
      break
      // Peru
      case 2:
        if(Number(this.appointment.brandId) === 4 || Number(this.appointment.brandId) === 5 || Number(this.appointment.brandId) === 6){
          DataRange = 45;
        }
      break
      // Chile
      case 3:
          if(Number(this.appointment.brandId) === 4 || Number(this.appointment.brandId) === 5 || Number(this.appointment.brandId) === 6){
            DataRange = 30;
          }
      break
      // Belgica
      case 4:
        if(Number(this.appointment.brandId) === 7){
          DataRange = 45;
        }
      break
      case 7:
        if(Number(this.appointment.brandId) === 19){
          DataRange = 45;
        }
      break
    }


    if(this.availableWorkshops){

      const avidablehoursWorkshop = this.availableWorkshops.filter(workshop =>workshop.workshopId === this.reScheduleForm.value.schedule?.taller)[0]
      DataRange = avidablehoursWorkshop.dateLength;
    }

    if(this.dateRangeReschedulerAdvisor){
      DataRange = this.dateRangeReschedulerAdvisor}

   if(this.DateLengthWorkshop){
    DataRange = this.DateLengthWorkshop.dateLength }

    // generate end of each blockade sorted it and turn it into an object
    let sortedTimes:any = unavailableHours.map(hour => {
      let momentObj
      let formattedTime
      if(!hour.name){

        momentObj = moment(hour,"HH:mm:ss").add(DataRange, 'm');
        formattedTime = momentObj.format('HH:mm:ss');

        return {
          start: hour,
          end: formattedTime
        }
      }
      return{
        name : hour.name,
        start: hour.blockStart,
        end: hour.blockEnd,
      }
    })


    // From here on we have the logic to get the advisorAttention hours
    // the hour cant be inside a blockade neither can be less than the time necesary for a full schedule

    const interval = 5;                   // Interval in minutes
    let timeDate = 0                      // Time appoiment route
    let Hourtemp = ""                     // Hour start save after route
    let blockSelect                       // Block select for Hour
    let hourInitialBlockedServices = 0    // Hour Initial Bloqued
    let hourFinalBlockedServices = 0      // Hour Final Bloqued
    let hourForInDecimal = 0              // route For
    let finalNewBloquedHour = 0
    const DateSelect : any= this.reScheduleForm.get("schedule")?.get("fecha")?.value

    if(new Date().getDate() === new Date(DateSelect).getDate() && new Date().getMonth() === new Date(DateSelect).getMonth() && new Date().getFullYear() === new Date(DateSelect).getFullYear()){
      let fristHour = new Date().getHours()+1
     sortedTimes.push({end:fristHour+":00:00",start:"01:00:00" })
    }

    if(new Date().getDate() > new Date(DateSelect).getDate() && new Date().getMonth() >= new Date(DateSelect).getMonth() && new Date().getFullYear() === new Date(DateSelect).getFullYear()){
     sortedTimes.push({end:"23:30:00",start:"01:00:00" })
    }

    for (let i = moment.duration("01:00:00").asHours(); i < moment.duration("23:30:00").asHours(); i++)
    {
      for (let j = 0; j < 60; j += interval)
      {
        let time = ('0' + i).slice(-2) + ':' + ('0' + j).slice(-2)+':00';

        hourForInDecimal = moment.duration(moment(time, "h:mm A.A.").format("HH:mm:ss")).asHours()
        blockSelect = sortedTimes.filter(blockHours => blockHours.start === time)

        if(blockSelect.length > 0)

          {

             finalNewBloquedHour= moment.duration(blockSelect[0].end).asHours()
            blockSelect.forEach(blockHours => {

              if(moment.duration(blockHours.end).asHours()>=finalNewBloquedHour){
                 finalNewBloquedHour= moment.duration(blockHours.end).asHours()
              }
            }
            )
              if(finalNewBloquedHour>=hourFinalBlockedServices )
                {
                  hourInitialBlockedServices = moment.duration(blockSelect[0].start).asHours()
                  hourFinalBlockedServices = finalNewBloquedHour
                }
          }


          if(hourForInDecimal>=HourInitial &&   hourForInDecimal<=HourFinal)
          {

              if (hourInitialBlockedServices<= hourForInDecimal && hourForInDecimal <  hourFinalBlockedServices)
                {
                  timeDate = 0 // Reset the time date for block
                }
              else if(hourForInDecimal>= hourFinalBlockedServices)
                {
                  if(timeDate===0)
                    {
                      Hourtemp = time // Select start time for appoiment
                    }
                  timeDate = timeDate + interval

                  if(timeDate===Number(DataRange) )
                    {
                      timeDate = 0
                      let formattedTime = moment(Hourtemp, 'HH:mm:ss').format('h:mm A');
                      hours.push(formattedTime);
                    }
                }
          }
      }
    }
    return hours;
  }

  formatoFecha(fecha: string, region:string): string {

    let fechaObj = new Date(fecha + 'T00:00:00');
    fechaObj.setMinutes(fechaObj.getTimezoneOffset());

    // Define days and months names for Spanish and English
    const diasSemana = {
      'es-CO': ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
      'en-US': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    };
    const meses = {
      'es-CO': ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
      'en-US': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    };

    // Get the day of the week and the day of the month in the desired language
    const diaSemana = diasSemana[region][fechaObj.getUTCDay()];
    const diaMes = fechaObj.getUTCDate();
    const mes = meses[region][fechaObj.getUTCMonth()];

    // Concatenate the values obtained to form the date string in the desired format
    let fechaFormateada = region === 'es-CO'
      ? `${diaSemana} ${diaMes} de ${mes}`
      : `${diaSemana}, ${mes} ${diaMes}`;

    return fechaFormateada;
  }
  convertTo24Hour(time) {
    // split the time string into hours, minutes, and AM/PM indicator
    let [hours, minutes, indicator] = time.split(/[:\s]/);

     // convert hours to integer
     hours = parseInt(hours);

    // check if the indicator is "PM" and the hours are less than 12, then add 12 hours
    if (indicator === "PM" && hours < 12) {
      hours += 12;
    }

    // check if the indicator is "AM" and the hours are 12, then subtract 12 hours
    if (indicator === "AM" && hours === 12) {
      hours -= 12;
    }

    // pad hours and minutes with leading zeroes
    hours = hours.toString().padStart(2, "0");
    minutes = minutes.padStart(2, "0");

    // return the time in 24-hour format as a string
    return `${hours}:${minutes}:00`;
  }

  //Filter Dates
  myFilter = (d: Date | null): boolean => {

    let allowedDays: number[] = [];
    let blockedDates: Date[] = this.loDeBloquear;
    let blockedDatesadvisor: Date[] = this.loDeBloquearAdvisor
    let today = new Date();
    today.setDate(today.getDate() -1)

    this.advisorAttentionSchedule.forEach((item) => {
      const itemDayNumber = Number(item.dayNumber);
      allowedDays.push(itemDayNumber);
    });

    if (d) {

      if (blockedDates.find((day) => new Date(day).toDateString() === new Date(d).toDateString())||blockedDatesadvisor.find((day) => new Date(day).toDateString() === new Date(d).toDateString())) {

        return false;
      }
      // check if the selected date is before today's date if it is block it
      if (d  <= today) {
        return false;
      }
    }

    let selectedDay = d ? d.getDay() : today.getDay();

    return allowedDays.includes(selectedDay);
  };

  // get interval of hours
  getTimeIntervals(startTimeStr, endTimeStr) {
    let time = 30;
    if(this.availableWorkshops){

      const avidablehoursWorkshop = this.availableWorkshops.filter(workshop =>workshop.workshopId === this.reScheduleForm.value.schedule?.taller)[0]
      time = avidablehoursWorkshop.dateLength;
    }
    const startTime = new Date(startTimeStr);
    const endTime = new Date(endTimeStr);
    const intervals: any[] = [];
    let current = new Date(startTime);
    while (current < endTime) {
      intervals.push(this.formatTime(current));
      current.setMinutes(current.getMinutes() + time);
    }
    return intervals;
  }

  formatTime(date) {

    const hours =('0' + date.getHours()).slice(-2);
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm ='00';
    return `${hours}:${minutes}:${ampm}`;
  }

// Save appointment Funcion

  onSave() {
    this.isSaving = true;
    const ownerRaw = this.reScheduleForm.get('owner')?.getRawValue();
    let formattedHour = this.convertTo24Hour(this.reScheduleForm.get("schedule")?.get("hora")?.value)
    let newSchedule : CreateSchedulerData | any;
    let dateSelected = this.formatoFecha(moment(this.reScheduleForm.get("schedule")?.get("fecha")?.value).format('YYYY-MM-DD HH:mm').split(" ")[0],this.helperService.user.language)
    const DateFormat= this.titleCasePipe.transform(`${new Date(moment(this.reScheduleForm.get("schedule")?.get("fecha")?.value).format('YYYY-MM-DD HH:mm')).
    toLocaleDateString(this.helperService.user.language, { weekday: 'long', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true })}`);

      if(this.reScheduleForm.get("representative.duenoSePresentara")!.value){
          this.reScheduleForm.get("representative.representativeId")?.reset(0);
          this.reScheduleForm.get("representative.numeroDeDocumentoRepresentante")?.reset("");
          this.reScheduleForm.get("representative.tipoDeDocumentoRepresentante")?.reset("");
          this.reScheduleForm.get("representative.nombresRepresentante")?.reset("");
          this.reScheduleForm.get("representative.apellidosRepresentante")?.reset("");
          this.reScheduleForm.get("representative.emailRepresentante")?.reset("");
          this.reScheduleForm.get("representative.celularRepresentante")?.reset("");
        }

      newSchedule = {
        createSchedulerDTO: {
          scheduleId: Number(this.appointment.id),
          customerId: this.customerIdRole1,
          advisorId: this.currentUserRoleId === 1 ? (this.helperService.user.advisorId ? this.helperService.user.advisorId : this.appointment.advisorId) : this.reScheduleForm.get("schedule")?.get("asesor")?.value,
          vehicleId: this.vechicleIdRole1,
          date: moment(this.reScheduleForm.get("schedule")?.get("fecha")?.value).format('YYYY-MM-DD HH:mm').split(" ")[0],
          time: formattedHour,
          observations: String(this.reScheduleForm.get("schedule")?.get("observacion")?.value),
          ownerOnSite: Boolean(this.reScheduleForm.get("representative")?.get("duenoSePresentara")?.value),
          termsAndConditions: true, // has to be true to submit the form anyway
          dataProtectionPolitics: true, // has to be true to submit the form anyway
          representativeId: Number(this.reScheduleForm.get("representative.representativeId")!.value),
          decisionMaking: true, // true siempre
          countryBrandRetailId: this.currentUserRoleId === 3 || this.currentUserRoleId === 4 ? this.reScheduleForm.get("schedule")!.get("taller")!.value : this.countryBrandRetaildIdSelected,
          schedulerStatusId: 4,
          serviceId: Number(this.reScheduleForm.get("schedule")?.get("tipoDeServicio")?.value),
          originId: this.appointment.originId,
          DataProcessing: false
        },
        vehicleDataDTO: {
          vehicleId: this.vechicleIdRole1,
          plate: String(this.reScheduleForm.get("owner")?.get("placa")?.value).toUpperCase(),
          vin: String(this.reScheduleForm.get("owner")?.get("vin")?.value),
        
          brand: this.appointment.brandName,
          mileage: String(this.reScheduleForm.get("schedule")?.get("kilometraje")?.value),
          customerId: this.customerIdRole1 ,
          ModelDescription: String(this.reScheduleForm.get("owner")?.get("model")?.value),
          ModelYear: String(this.reScheduleForm.get("owner")?.get("año")?.value)
        },
        customerBasicDataDTO: {
          customerId: this.customerIdRole1,
          sapCustomerId: "", // string vacia o null?
          identification: String(ownerRaw?.numeroDeDocumento),
          personTypeId: Number(ownerRaw?.tipoDePersona),
          documentType: Number(ownerRaw?.tipoDeDocumento),
          firstName: String(this.reScheduleForm.get("owner")?.get("nombres")?.value),
          lastName: this.showLastName ? String(this.reScheduleForm.get("owner")?.get("apellidos")?.value):'NaN',
          email: String(this.reScheduleForm.get("owner")?.get("email")?.value),
          phone: String(this.reScheduleForm.get("owner")?.get("celular")?.value),
          address: "", // nunca se pide
          relationshipVehicleId: Number(this.reScheduleForm.get("owner")?.get("relacionClienteVehiculo")?.value),
          dataPrivacy: this.countryId == 2 ? this.reScheduleForm.get("termsAndPolitics")?.get("DataPeru")?.value : this.reScheduleForm.get("termsAndPolitics")?.get("politicas")?.value 
        },
        representativeDTO :  {
          representativeId: Number(this.reScheduleForm.get("representative.representativeId")!.value),
          customerId: Boolean( this.reScheduleForm.get("representative")?.get("duenoSePresentara")?.value) == true ? 0 : this.customerIdRole1,
          identification: String(this.reScheduleForm.get("representative")?.get("numeroDeDocumentoRepresentante")?.value),
          documentType: Number(this.reScheduleForm.get("representative")?.get("tipoDeDocumentoRepresentante")?.value),
          firstName: String(this.reScheduleForm.get("representative")?.get("nombresRepresentante")?.value),
          lastName: String( this.reScheduleForm.get("representative")?.get("apellidosRepresentante")?.value),
          email: String( this.reScheduleForm.get("representative")?.get("emailRepresentante")?.value),
          phone: String(this.reScheduleForm.get("representative")?.get("celularRepresentante")?.value),
          address: "" // nunca se pide...
        },
        utmDTO: {
          UtmSource:"" ,
          UtmCampaign:"" ,
          UtmMedium:"" ,
          UtmContent:"" ,
          UtmTerm: ""
        }
        ,
         RecaptchaToken:"OK"
      };

      newSchedule.createSchedulerDTO.UserId = Number(this.helperService.user.userid);


    const serviceNameSelected = this.translate.instant(
      this.typeOfServices.find(service => service.serviceId === this.reScheduleForm.get("schedule")?.get("tipoDeServicio")?.value).serviceName
    )

    this.schedulerService.postDataScheduler(newSchedule)
    .subscribe({
      next: (res) => {
        // console.log(res)
        if (res.scheduleResult.scheduleId) {
          this.isSaving = false
          const translateText= this.translate.instant('ReScheduleSavedSuccess', {
            serviceNameSelected: this.translate.instant(serviceNameSelected),
            dateSelected: dateSelected,
            time:this.reScheduleForm.value.schedule?.hora
          });
          this.helperService.showAlert =true
          this.helperService.typeAlert ="success"
          this.helperService.messageAlert =translateText
          setTimeout(() => {
            this.helperService.showAlert =false
            }, 7000)
          this.scheduleStateService.changeScheduleState(true)
          this.dialogRef.close(this.appointment);
        } else {
          const trasnlateTextFail = this.translate.instant("ScheduleSavedFailure",{Date:DateFormat})

          this.helperService.showAlert =true
          this.helperService.typeAlert ="warning"
         this.helperService.messageAlert =trasnlateTextFail
          setTimeout(() => {
          this.helperService.showAlert =false
          }, 7000)
        }

      },
      error: (err) => {
        console.error(err)
        if(err.status === 401){
          this.helperService.logoutToken()
        }else{
        const trasnlateTextFail = this.translate.instant("ScheduleSavedFailure",{Date:DateFormat})
        this.helperService.showAlert =true
        this.helperService.typeAlert ="warning"
        this.helperService.messageAlert =trasnlateTextFail

        setTimeout(() => {
          this.helperService.showAlert =false
          }, 7000)}
      },
      complete: () => {
        this.dialogRef.close(this.appointment);
      }
    });

  }

 // --Form field getters to avoid long code in the template--


  validatorsForm():boolean{
    const invalidForms=
    this.reScheduleForm.get('owner')!.invalid
    ||this.reScheduleForm.get('schedule')!.invalid
    ||this.reScheduleForm.get('termsAndPolitics')!.invalid
    ||this.reScheduleForm.get('schedule')!.get('hora')!.value===""


    const ownerOnsiteValidation=
    this.reScheduleForm.get('representative')!.get('duenoSePresentara')!.value
    if(!invalidForms&&ownerOnsiteValidation && this.availableAdvisorHours.length>0){
      return false
    }
    else if(!invalidForms&&!ownerOnsiteValidation){
      return this.reScheduleForm.get('representative')!.invalid
    }

    else{
      return true
    }

  }

  get nombres (){
    return this.reScheduleForm.get("owner")?.get("nombres")
  }

  get apellidos (){
    return this.reScheduleForm.get("owner")?.get("apellidos")
  }

  get tipoDePersona (){
    return this.reScheduleForm.get("owner")?.get("tipoDePersona")
  }
  
  get tipoDeDocumento (){
    return this.reScheduleForm.get("owner")?.get("tipoDeDocumento")
  }

  get numeroDeDocumento (){
    return this.reScheduleForm.get("owner")?.get("numeroDeDocumento")
  }

  get relacionClienteVehiculo (){
    return this.reScheduleForm.get("owner")?.get("relacionClienteVehiculo")
  }

  get celular (){
    return this.reScheduleForm.get("owner")?.get("celular")
  }

  get email (){
    return this.reScheduleForm.get("owner")?.get("email")
  }

  get placa (){
    return this.reScheduleForm.get("owner")?.get("placa")
  }

  // TODO: Modify this to be only vin not vinNo
  get vinNo (){
    return this.reScheduleForm.get("owner")?.get("vin")
  }
  get year (){
    return this.reScheduleForm.get("owner")?.get("año")
  }
  get model (){
    return this.reScheduleForm.get("owner")?.get("model")
  }

  get tipoDeServicio (){
    return this.reScheduleForm.get("schedule")?.get("tipoDeServicio")
  }

  get taller (){
    return this.reScheduleForm.get("schedule")?.get("taller")
  }

  get asesor (){
    return this.reScheduleForm.get("schedule")?.get("asesor")
  }

  get fecha (){
    return this.reScheduleForm.get("schedule")?.get("fecha")
  }

  get hora (){
    return this.reScheduleForm.get("schedule")?.get("hora")
  }

  get terminos (){
    return this.reScheduleForm.get("termsAndPolitics")?.get("terminos")
  }

  get politicas (){
    return this.reScheduleForm.get("termsAndPolitics")?.get("politicas")
  }

  // representante

  get nombresRepresentante (){
    return this.reScheduleForm.get("representative")?.get("nombresRepresentante")
  }

  get apellidosRepresentante (){
    return this.reScheduleForm.get("representative")?.get("apellidosRepresentante")
  }

  get tipoDeDocumentoRepresentante (){
    return this.reScheduleForm.get("representative")?.get("tipoDeDocumentoRepresentante")
  }

  get numeroDeDocumentoRepresentante (){
    return this.reScheduleForm.get("representative")?.get("numeroDeDocumentoRepresentante")
  }

  get relacionClienteVehiculoRepresentante (){
    return this.reScheduleForm.get("representative")?.get("relacionClienteVehiculoRepresentante")
  }

  get celularRepresentante (){
    return this.reScheduleForm.get("representative")?.get("celularRepresentante")
  }

  get emailRepresentante (){
    return this.reScheduleForm.get("representative")?.get("emailRepresentante")
  }

  get kilometraje (){
    return this.reScheduleForm.get("schedule")?.get("kilometraje")
  }


}
